import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  MSAL_INSTANCE,
  MsalBroadcastService,
  MsalService,
} from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { AuthService } from './core/auth/auth.service';
import { buildMsalInstance } from './core/auth/msal.config';
import { FeatureAccessService } from './core/feature-access/feature-access.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    { provide: MSAL_INSTANCE, useFactory: buildMsalInstance },
    MsalService,
    MsalBroadcastService,
    provideAppInitializer(async () => {
      const msal = inject(MsalService);
      const auth = inject(AuthService);
      const featureAccess = inject(FeatureAccessService);
      await firstValueFrom(msal.initialize());
      await auth.handleRedirectResponse();
      await featureAccess.load();
    }),
    provideRouter(routes, withComponentInputBinding()),
  ],
};
